import { Reducer } from 'redux';
import { findIndex } from 'lodash-es';

import {
    AiTextState,
    ActionTypes,
    AiTextGenerateStartAction,
    AiTextGenerateEndAction,
    AiTextSetInputValueAction,
} from './types';

const defaultState: AiTextState = {
    list: [],
    isBusy: false,
    inputValue: '',
};

const setInputValue = (state: AiTextState, action: AiTextSetInputValueAction): AiTextState => ({
    ...state,
    inputValue: action.payload.value,
});

const generateStart = (state: AiTextState, action: AiTextGenerateStartAction): AiTextState => ({
    ...state,
    list: [...state.list, action.payload.item],
    isBusy: true,
    inputValue: '',
});

const generateEnd = (state: AiTextState, action: AiTextGenerateEndAction): AiTextState => {
    const { item } = action.payload;
    const itemIndex = findIndex(state.list, { timestamp: item.timestamp });
    let newList;
    if (itemIndex > -1) {
        newList = [...state.list];
        newList.splice(itemIndex, 1, item);
    }

    return {
        ...state,
        list: newList,
        isBusy: false,
    };
};

const reducer: Reducer<AiTextState> = (state: AiTextState = defaultState, action): AiTextState => {
    switch (action.type) {
        case ActionTypes.SET_INPUT_VALUE:
            return setInputValue(state, action as AiTextSetInputValueAction);
        case ActionTypes.GENERATE_START:
            return generateStart(state, action as AiTextGenerateStartAction);
        case ActionTypes.GENERATE_END:
            return generateEnd(state, action as AiTextGenerateEndAction);
        default:
            return state;
    }
};

export { reducer as aiText };

export default reducer;
